module.exports = __webpack_public_path__ + "img/btn2.png";